"use client";

import { useEffect, useState } from "react";

export const useOrientation = (): "portrait" | "landscape" => {
  const [isPortrait, setIsPortrait] = useState(true);

  useEffect(() => {
    const media = window.matchMedia("(orientation: portrait)");

    const handler = () => setIsPortrait(media.matches);

    handler();
    media.addEventListener("change", handler);

    return () => media.removeEventListener("change", handler);
  }, []);

  return isPortrait ? "portrait" : "landscape";
};
